export function scriptInsert(url, callBack) {
	const
		script = document.createElement("script");
	script.type = "text/javascript";
	script.src = url;
	document.getElementsByTagName('head')[0].appendChild(script);
	if (callBack) {
		script.onload = function () {
			callBack();
		}
	}
}
export function getUrlParam() {
	let
		navUrl = window.location.search,
		Param = {};
	if (navUrl.indexOf("?") !== -1) {
		let
			str = navUrl.substr(1),
			strs = str.split("&");
		for (let i = 0, max = strs.length; i < max; i++) {
			Param[strs[i].split("=")[0]] = unescape(
				strs[i].split("=")[1]
			);
		}
	}
	return Param;
}
export function useSession(key, value) {
	if (value) {
		if (value == 'delete') {
			window.sessionStorage.removeItem(key);
			return false;
		}
		window.sessionStorage.setItem(key, JSON.stringify(value));
	} else {
		return JSON.parse(window.sessionStorage.getItem(key));
	}
}
export function useLocal(key, value) {
	if (value) {
		if (value == 'delete') {
			window.localStorage.removeItem(key);
			return false;
		}
		window.localStorage.setItem(key, JSON.stringify(value));
	} else {
		return JSON.parse(window.localStorage.getItem(key));
	}
}


export function iosDetect() {
	const
		ua = navigator.userAgent,
		ios = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	return ios;
}
export function wapDetect() {
	const
		ua = navigator.userAgent.toLocaleLowerCase();
	return ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}
export function lazyComponent(AsyncView, loadView) {
	const AsyncHandler = () => ({
		// 需要加载的组件 (应该是一个 `Promise` 对象)
		component: AsyncView,
		// 异步组件加载时使用的组件
		loading: loadView,
		// 加载失败时使用的组件
		error: loadView,
		// 展示加载时组件的延时时间。默认值是 200 (毫秒)
		delay: 0,
		// 如果提供了超时时间且组件加载也超时了，
		// 则使用加载失败时使用的组件。默认值是：`Infinity`
		timeout: 10000
	});
	return Promise.resolve({
		functional: true,
		render(h, { data, children }) {
			return h(AsyncHandler, data, children);
		}
	});
}